import React, {FC} from "react"
import {Row} from "react-bootstrap"
import styled from "styled-components"

import {CompanyNewsTile} from "@irati/types"

import calculateHeightFromContent from "../utils/calculateHeightFromContent"
import {HomePageView} from "../../types"
import Content from "./Content"
import {isRowEmpty} from "../utils/isRowEmpty"

interface Props {
  companyNewsRow: CompanyNewsTile[]
  pageView: HomePageView
}

interface StyledRowProps {
  rowHeight?: number
}

const StyledRow = styled(({rowHeight, ...rest}) => <Row {...rest} />)`
  display: flex;
  flex-wrap: wrap;
  &:before,
  &:after {
    display: none;
  }
  min-height: ${(props: StyledRowProps) => (props.rowHeight ? `${props.rowHeight + 30}px` : "")};
`

const ContentColumns: FC<Props> = ({companyNewsRow, pageView}) => {
  const isEmptyRow = isRowEmpty(companyNewsRow)
  return (
    <StyledRow rowHeight={isEmptyRow ? calculateHeightFromContent(companyNewsRow) : undefined}>
      {companyNewsRow.map((companyNewsTile, i) => (
        <Content companyNewsTile={companyNewsTile} key={i} pageView={pageView} />
      ))}
    </StyledRow>
  )
}

export default ContentColumns
